<template>
  <section>
    <div class="container">
      <div class="hero is-bold" v-if="!specialOffersEnabled">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Menus</h1>
            <h5 class="subtitle">Manage your menus here. Menus are image-only and each cluster can have up to one menu.
            </h5>
          </div>
        </div>
      </div>

      <div class="hero is-bold" v-else>
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Special Offers</h1>
            <h5 class="subtitle">Manage your special offer menus here. They are image-only and each cluster can have up
              to one special offer menu.</h5>
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-mobile" v-if="!specialOffersEnabled">
        <div class="column is-4 is-offset-1 box" v-for="(menu,id) in menus" :key="id">
          <div class="level">
            <div class="level-left">
              <!-- <router-link style="font-size:17.5px;color:#3e8ed0" class="level-item" :to="{ name: 'MenuDetails', params: { id: id }}" ><b>{{menu.name}}</b></router-link> -->
              <div style="font-size:17.5px;color:#3e8ed0;cursor:pointer" class="level-item"
                @click="editMenu(id, false)"><b>{{showMenuName(menu.name)}}</b></div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info" @click="editMenu(id, false)">Edit</b-button>
              </div>
              <div class="level-item">
                <b-button :disabled="role === 'viewer'" icon-left="trash" class="button is-danger" @click="confirmRemove(id, menu.name, false)">
                </b-button>
              </div>
            </div>
          </div>
          <p><b>Number of items: </b>{{menu.items ? menu.items.filter(x => x).length : 'N/A'}}</p>
        </div>
        <div></div>
      </div>

      <div class="columns is-multiline is-mobile" v-else>
        <div class="column is-4 is-offset-1 box" v-for="(menu,id) in specialOffers" :key="id">
          <div class="level">
            <div class="level-left">
              <!-- <router-link style="font-size:17.5px;color:#3e8ed0" class="level-item" :to="{ name: 'SpecialOfferDetails', props:{ isSpecialOffer: true }, params: { id: id }}" ><b>{{menu.name}}</b></router-link> -->
              <div style="font-size:17.5px;color:#3e8ed0;cursor:pointer" class="level-item" @click="editMenu(id, true)">
                <b>{{showMenuName(menu.name)}}</b>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info" @click="editMenu(id, true)">Edit</b-button>
              </div>
              <div class="level-item">
                <b-button :disabled="role === 'viewer'" icon-left="trash" class="button is-danger" @click="confirmRemove(id, menu.name, true)">
                </b-button>
              </div>
            </div>
          </div>
          <p><b>Number of items:</b> {{menu.items ? menu.items.filter(x => x).length : 'N/A'}}</p>
        </div>
        <div></div>
      </div>
      <vue-fab v-if="!bAddMenu" :title="specialOffersEnabled ? 'Add Special Offers Menu' : 'Add Menu'"
        :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big"
        @clickMainBtn="specialOffersEnabled ? addMenu(true) : addMenu(false)" :hidden="role === 'viewer'" />
    </div>
  </section>
</template>

<script>
// import * as firebase from 'firebase'
import MenuAddEdit from '@/components/menu/MenuAddEdit'

export default {
  name: 'Menus',
  props: ['specialOffersEnabled'],
  data: () => {
    return {
      bAddMenu: false,
      loadingComponent: null,
      autoHide: false,
      archiveItems: [],
      jsonResp: null
    }
  },
  computed: {
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
  },
  mounted: function () {
    this.globalLogger('mounted')
    // firebase.analytics().logEvent('menus_view')
    // this.$analytics.logEvent('menus_view')
    this.refreshData()
  },
  methods: {
    addMenu (isSpecial) {
      // this.$analytics.logEvent('add_menu_modal')
      /* this.$analytics.logEvent('add_menu_modal', {
        param_one: 'one',
        param_two: 'two'
      }) */
      this.bAddMenu = true
      this.$buefy.modal.open({
        parent: this,
        component: MenuAddEdit,
        props: { propParentFn: this.cancelAdd, isSpecialOffer: isSpecial },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    editMenu (id, isSpecial) {
      this.bAddMenu = true
      const modal = this.$buefy.modal.open({
        parent: this,
        component: MenuAddEdit,
        props: { editEnabled: true, propId: id, propParentFn: this.cancelAdd, isSpecialOffer: isSpecial },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
      modal.$on('close', () => {
        this.refreshData()
      })
    },
    confirmRemove (id, menuName, isSpecial) {
      if (this.role !== 'viewer') {
        var flag = false
        var menuRef = null
        if (isSpecial) {
          menuRef = Object.assign({}, this.$store.getters.getSpecialOffer(id))
        } else {
          menuRef = Object.assign({}, this.$store.getters.getMenu(id))
        }
        this.globalLogger(menuRef.items, 'menurefitems')
        if (menuRef.items !== undefined) {
          flag = true
        }
        this.$buefy.dialog.confirm({
          title: 'Delete menu',
          message: 'Are you sure you want to <b>delete</b> menu "' + menuName + '"? This action cannot be undone.',
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            if (flag) {
              this.$buefy.dialog.confirm({
                message: 'Do you also want to delete the resources associated with this menu?',
                cancelText: 'Archive resources',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  this.removeMenu(id, isSpecial, true, true)
                },
                onCancel: () => {
                  this.globalLogger('onCancel')
                  this.loadingComponent = this.$buefy.loading.open()
                  var menuRef = null
                  if (isSpecial) {
                    menuRef = Object.assign({}, this.$store.getters.getSpecialOffer(id))
                  } else {
                    menuRef = Object.assign({}, this.$store.getters.getMenu(id))
                  }
                  var menuItems = [...menuRef.items.filter(x => x)]

                  var count1 = 0
                  var archiveItemsCopy = []
                  for (let z = 0; z < this.archiveItems.length; z++) {
                    archiveItemsCopy[z] = this.archiveItems[z]
                  }

                  for (let i = 0; i < menuItems.length; i++) {
                    if (menuItems[i].resourceSize !== undefined) {
                      var zn = 1
                      for (let j = 0; j < archiveItemsCopy.length; j++) {
                        if (archiveItemsCopy[j].resName === menuItems[i].resourceName && archiveItemsCopy[j].resSize === menuItems[i].resourceSize) {
                          zn = 0
                        } else if (archiveItemsCopy[j].resName === menuItems[i].resourceName) {
                          this.globalLogger('samo imeto')
                          archiveItemsCopy = archiveItemsCopy.filter(x => x.resName !== menuItems[i].resourceName)
                        }
                      }
                      if (zn === 1) {
                        count1++
                        archiveItemsCopy.push({ 'resName': menuItems[i].resourceName, 'resSize': menuItems[i].resourceSize })
                      }
                    }
                  }

                  let dirRef = null
                  var flag = 0
                  if (isSpecial) {
                    if (!this.getNotMigrated().includes(this.userId)) {
                      dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + id)
                    } else {
                      dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + id)
                    }
                  } else {
                    if (!this.getNotMigrated().includes(this.userId)) {
                      dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + id)
                    } else {
                      dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + id)
                    }
                  }
                  var count2 = 0
                  dirRef.listAll().then((dir) => {
                    dir.items.forEach(fileRef => {
                      fileRef.getDownloadURL().then((url) => {
                        const xhr = new XMLHttpRequest()
                        xhr.responseType = 'blob'
                        xhr.onload = (event) => {
                          const blob = xhr.response
                          var file = new File([blob], fileRef.name, { type: blob.type })
                          this.globalLogger('file', file)
                          let ref = null
                          if (isSpecial) {
                            if (!this.getNotMigrated().includes(this.userId)) {
                              ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/' + fileRef.name)
                            } else {
                              ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/' + fileRef.name)
                            }
                          } else {
                            if (!this.getNotMigrated().includes(this.userId)) {
                              ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/MenusArchive/' + fileRef.name)
                            } else {
                              ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/MenusArchive/' + fileRef.name)
                            }
                          }
                          ref.put(file).then((snapshot) => {
                            ref.getDownloadURL().then((url) => {
                              var zn = 1
                              for (let j = 0; j < this.archiveItems.length; j++) {
                                // this.globalLogger(this.archiveItems[j].resName, file.name, this.archiveItems[j].resSize, file.size)
                                if (this.archiveItems[j].resName === file.name && this.archiveItems[j].resSize === file.size) {
                                  this.globalLogger('zn e 0')
                                  zn = 0
                                } else if (this.archiveItems[j].resName === file.name) {
                                  this.globalLogger('samo imeto')
                                  this.archiveItems = this.archiveItems.filter(x => x.resName !== file.name)
                                }
                              }
                              if (zn === 1) {
                                count2++
                                this.globalLogger(count2, 'count2')
                                this.globalLogger('zn e 1')
                                this.archiveItems.push({ 'resName': file.name, 'resSize': file.size })
                              }
                              this.globalLogger('File ' + file.name + ' successfully uploaded at ' + url)
                            }).finally(() => {
                              this.globalLogger('finally new', this.archiveItems)
                              if (isSpecial) {
                                if (!this.getNotMigrated().includes(this.userId)) {
                                  this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/specialOffers/').update({
                                    items: this.archiveItems
                                  })
                                } else {
                                  this.$store.state.database.ref('/archive/' + this.userId + '/specialOffers/').update({
                                    items: this.archiveItems
                                  })
                                }
                              } else {
                                if (!this.getNotMigrated().includes(this.userId)) {
                                  this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/menus/').update({
                                    items: this.archiveItems
                                  })
                                } else {
                                  this.$store.state.database.ref('/archive/' + this.userId + '/menus/').update({
                                    items: this.archiveItems
                                  })
                                }
                              }
                              if (flag === 0) {
                                this.globalLogger('FLAG = 0')
                                this.removeMenu(id, isSpecial, false, false)
                              }
                              flag = 1
                            }).finally(() => {
                              this.globalLogger('second finally')
                              this.globalLogger(count1, count2)
                              if (count1 === count2) {
                                this.globalLogger('uslov ispolnet')
                                this.loadingComponent.close()
                                this.$buefy.toast.open({
                                  duration: 3000,
                                  message: 'The resources are archived.'
                                })
                              }
                            })
                          }).catch(error => {
                            this.globalLogger('Submit files error: ', error)
                          })
                        }
                        xhr.open('GET', url)
                        this.globalLogger('url', url)
                        xhr.send()
                      }).catch((error) => {
                        this.globalLogger('error', error)
                      })
                    })
                  })
                }
              })
            } else {
              this.removeMenu(id, isSpecial, true, false)
            }
          }
        })
      }
    },
    removeMenu (id, isSpecial, shouldLoad, shouldToast) {
      var objToRemove = null
      var objToRemoveLog = null
      var names = []
      if (this.specialOffersEnabled) {
        objToRemove = this.$store.getters.getSpecialOffer(id)
        objToRemoveLog = Object.assign({}, objToRemove)
        objToRemoveLog.offerId = id
        objToRemoveLog.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
        objToRemoveLog.city = this.jsonResp ? this.jsonResp.city : ''
        for (let it in objToRemove.items) {
          names.push(objToRemove.items[it].name)
        }
        objToRemoveLog.offerItems = names
        this.$analytics.logEvent('delete_offer', objToRemoveLog)
      } else {
        objToRemove = this.$store.getters.getMenu(id)
        objToRemoveLog = Object.assign({}, objToRemove)
        objToRemoveLog.offerId = id
        objToRemoveLog.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
        objToRemoveLog.city = this.jsonResp ? this.jsonResp.city : ''
        for (let it in objToRemove.items) {
          names.push(objToRemove.items[it].name)
        }
        objToRemoveLog.menuItems = names
        this.$analytics.logEvent('delete_menu', objToRemoveLog)
        this.globalLogger(objToRemoveLog, 'OBJ TO REMOVE')
      }

      if (shouldLoad) {
        this.loadingComponent = this.$buefy.loading.open()
      }
      let associatedClustersRef = null
      if (isSpecial) {
        associatedClustersRef = this.$store.getters.getClustersForSpecialOffer(id)
      } else {
        associatedClustersRef = this.$store.getters.getClustersForMenu(id)
      }
      for (let cluster in associatedClustersRef) {
        if (isSpecial) {
          if (!this.getNotMigrated().includes(this.userId)) {
            this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + cluster).update({
              specialOffersMenuId: ''
            })
          } else {
            this.$store.state.database.ref('/clusters/' + this.userId + '/' + cluster).update({
              specialOffersMenuId: ''
            })
          }
        } else {
          if (!this.getNotMigrated().includes(this.userId)) {
            this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + cluster).update({
              menuId: ''
            })
          } else {
            this.$store.state.database.ref('/clusters/' + this.userId + '/' + cluster).update({
              menuId: ''
            })
          }
        }
      }
      let removeMenuRef = null
      if (isSpecial) {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuRef = this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + id)
        } else {
          removeMenuRef = this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + id)
        }
        // itemsMenuRef = Object.assign({}, this.$store.getters.getSpecialOffer(id))
      } else {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuRef = this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + id)
        } else {
          removeMenuRef = this.$store.state.database.ref('/menu/' + this.userId + '/' + id)
        }
      }
      // this.items = [...itemsMenuRef.items.filter(x => x)]
      removeMenuRef.remove()
      let removeMenuFilesRef = null
      if (isSpecial) {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + id)
        } else {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + id)
        }
      } else {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + id)
        } else {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + id)
        }
      }
      removeMenuFilesRef.listAll().then(dir => {
        dir.items.forEach(fileRef => {
          fileRef.delete().then(() => {
            this.globalLogger('deleted file' + fileRef.name)
          })
        })
        if (shouldLoad) {
          this.loadingComponent.close()
          if (shouldToast) {
            this.$buefy.toast.open({
              duration: 3000,
              message: 'The resources are deleted.'
            })
          }
        }
      })
    },
    cancelAdd () {
      this.bAddMenu = false
    },
    refreshData () {
      this.globalLogger('refresh Data')
      if (this.specialOffersEnabled) {
        if (this.$store.state.specialOffersArchive !== null) {
          this.archiveItems = this.$store.state.specialOffersArchive.items
          this.globalLogger('SO archive: ', this.archiveItems)
        }
      } else {
        if (this.$store.state.menusArchive !== null) {
          this.archiveItems = this.$store.state.menusArchive.items
          this.globalLogger('menus archive: ', this.archiveItems)
        }
      }
    },
    showMenuName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
.box {
  border: 0.5px solid rgb(212, 212, 212);
}
</style>



// WEBPACK FOOTER //
// src/components/menu/Menus.vue